/**
 * usePdfDownload Hook
 * 
 * Custom hook que encapsula la lógica de descarga de PDF
 * 
 * @param getPdfBlob - Función que obtiene el blob del PDF
 * @param openPdf - Función que abre el PDF
 * @param filename - Nombre del archivo PDF
 * @returns Estado de descarga y función para iniciar descarga
 */

import { useState } from 'react';

interface UsePdfDownloadReturn {
  isDownloading: boolean;
  downloadPdf: () => void;
}

export const usePdfDownload = (
  getPdfBlob: () => Promise<Blob | undefined>,
  openPdf: (blob: Blob, filename: string) => void,
  filename: string
): UsePdfDownloadReturn => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPdf = async () => {
    setIsDownloading(true);

    try {
      const pdfBlob = await getPdfBlob();

      if (!pdfBlob) {
        console.error('Failed to download PDF');
        return;
      }

      openPdf(pdfBlob, filename);
    } catch (error) {
      console.error('Error downloading PDF:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    isDownloading,
    downloadPdf,
  };
};
